import { useCallback, useMemo, useState } from "react";
import moment from "moment";

const DATE_FORMAT_UI = "MM/DD/YYYY";
const DATE_FORMAT_API = "YYYY-MM-DD";

export function useDesiredDeliveryDate() {
  const [uiValue, setUiValue] = useState("");

  const isValid = useMemo(() => {
    if (!uiValue) return true;
    return moment(uiValue, DATE_FORMAT_UI, true).isValid();
  }, [uiValue]);

  const apiValue = useMemo(() => {
    if (!uiValue) return undefined;
    if (!moment(uiValue, DATE_FORMAT_UI, true).isValid()) return undefined;
    return moment(uiValue, DATE_FORMAT_UI, true).format(DATE_FORMAT_API);
  }, [uiValue]);

  const reset = useCallback(() => setUiValue(""), []);

  return {
    uiValue,
    setUiValue,
    apiValue,
    isValid,
    reset,
    DATE_FORMAT_UI,
  };
}
